// @ts-ignore
import { authenticatedGet, authenticatedPost } from "../base/util/api";
// @ts-ignore
import { showError, showSuccess } from "../base/util/alerts";
// @ts-ignore
import StoreHandler from "../base/store";
// @ts-ignore
import { appNavigateBack } from "../base/navigation";
// @ts-ignore
import { logError } from "../base/util/alerts";
import { sortByOrder } from "./controllerSort";
// @ts-ignore
import { loadControllerWatches } from "../settings/settingsActions";

export const MIDNIGHT_VALUES_FETCH = "MIDNIGHT_DATA_FETCH";
export const MIDNIGHT_VALUES_SET = "MIDNIGHT_DATA_SET";
export const CONTROLLERS_ADMIN_SET = "CONTROLLERS_ADMIN_SET";
export const CONTROLLERS_SET = "CONTROLLERS_SET";
export const CONTROLLER_SELECTED_SET = "CONTROLLER_SELECTED_SET";
export const CONTROLLER_SELECTED_CLEAR = "CONTROLLER_SELECTED_CLEAR";
export const CONTROLLERS_FETCH = "CONTROLLERS_FETCH";
export const CONTROLLER_ORDER_MOVE = "CONTROLLER_ORDER_MOVE";

export const loadController = (id) => (dispatch) => {
  dispatch({ type: CONTROLLERS_FETCH });
  return authenticatedGet(`controller/${id}`)
    .then((res) => {
      dispatch({
        type: CONTROLLER_SELECTED_SET,
        controller: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

/**
 * Move a controller one place up or down in its dashboard section (#686).
 *
 * The store is updated first so the tile moves under the user's finger, then
 * the whole resulting order is persisted. Sending both sections every time is
 * idempotent and self-healing: it costs nothing and repairs any drift between
 * client and server.
 */
export const moveController =
  (controllerId, direction, section) => (dispatch, getState) => {
    dispatch({
      type: CONTROLLER_ORDER_MOVE,
      controllerId,
      direction,
      section,
    });

    const { list, watchedList } = getState().controllers;
    return authenticatedPost("controller/order", {
      ownedIds: sortByOrder(list).map((c) => c.id),
      watchedIds: sortByOrder(watchedList).map((c) => c.id),
    }).catch((msg) => {
      logError(msg.message);
      // Snap back to server truth rather than leaving a lie on screen.
      dispatch(loadControllers());
      dispatch(loadControllerWatches());
    });
  };

export const loadControllers = () => (dispatch) => {
  dispatch({ type: CONTROLLERS_FETCH });
  return authenticatedGet("controller")
    .then((res) => {
      dispatch({
        type: CONTROLLERS_SET,
        controllers: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const loadMidnightValues = (controllerId) => (dispatch) => {
  dispatch({ type: MIDNIGHT_VALUES_FETCH, controllerId });
  return authenticatedGet(`controller/${controllerId}/midnightvalues`)
    .then((res) => {
      dispatch({
        type: MIDNIGHT_VALUES_SET,
        controllerId,
        scales: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const loadAllControllers = () => (dispatch) => {
  dispatch({ type: CONTROLLERS_FETCH });
  return authenticatedGet("admin/controllers")
    .then((res) => {
      dispatch({
        type: CONTROLLERS_ADMIN_SET,
        controllers: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const loadAffiliatedControllers = (affiliationId) => (dispatch) => {
  dispatch({ type: CONTROLLERS_FETCH });
  return authenticatedGet(
    "admin/affiliatedControllers?affiliationId=" + affiliationId,
  )
    .then((res) => {
      dispatch({
        type: CONTROLLERS_ADMIN_SET,
        controllers: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const clearSelectedController = () => ({
  type: CONTROLLER_SELECTED_CLEAR,
});

export const MUTES_SET = "MUTES_SET";
export const loadMutes = (controllerId) => (dispatch) => {
  return authenticatedGet(`notification/mute?idcontroller=${controllerId}`)
    .then((res) => {
      dispatch({
        type: MUTES_SET,
        controllerId,
        mutes: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const registerController = (model) => (dispatch) => {
  return authenticatedPost("registration/controller", {
    ...model,
  });
};

export const updateController = (data) => {
  return (dispatch) => {
    const state = StoreHandler.store.getState();
    const id = data.id;

    // TODO: Clean up
    const list = state.controllers.list.map((c) => {
      if (c.imsi === id)
        return Object.assign(c, {
          name: data.name,
          location: data.location,
          updateInterval: data.updateInterval,
        });

      return c;
    });

    const adminList = state.controllers.adminList.map((c) => {
      if (c.imsi === id)
        return Object.assign(c, {
          name: data.name,
          location: data.location,
          updateInterval: data.updateInterval,
        });

      return c;
    });

    dispatch(setAdminControllers(adminList));
    dispatch(setControllers(list));

    authenticatedPost("admin/controller", {
      ...data,
      imsi: data.id,
    })
      .then((msg) => {
        showSuccess(msg.message);
        // back to wherever the settings were opened from (review #19)
        appNavigateBack("/settings");
      })
      .catch((msg) => showError(msg.message));
  };
};

export const setControllers = (controllers) => (dispatch) => {
  dispatch({
    type: CONTROLLERS_SET,
    controllers: controllers,
  });
};

export const setAdminControllers = (controllers) => (dispatch) => {
  dispatch({
    type: CONTROLLERS_ADMIN_SET,
    controllers: controllers,
  });
};

export const archiveChannel = (controllerId, channelId) => (dispatch) => {
  dispatch({ type: CONTROLLERS_FETCH });
  return authenticatedPost(
    `controller/${controllerId}/channel/${channelId}/archive`,
    {},
  )
    .then((msg) => {
      showSuccess(msg.message);
    })
    .catch((e) => {
      showError(e.message);
      // dispatch(fetching(false));
      throw e;
    });
};
